<script lang="ts" setup>
import ScanQr from '/images/bangkok/scan-qr.png'
import SignIn from '/images/bangkok/sing-in.png'
import GaslessNFTClaims from '/images/bangkok/gasless-nft-claims.png'
import UnlockPrize from '/images/bangkok/unlock-prize.png'

const { t } = useI18n()
const sliderArray = [
  {
    id: 0,
    image: ScanQr,
    title: t('scan-qr-codes-with-your-camera'),
    description: t('look-for-qr-codes'),
  },
  {
    id: 1,
    image: SignIn,
    title: t('simple-sign-up-and-wallet-creation'),
    description: t('signing-up-is-easy'),
  },
  {
    id: 2,
    image: GaslessNFTClaims,
    title: t('gasless-nft-claims'),
    description: t('after-scanning-the-qr-code'),
  },
  {
    id: 3,
    image: UnlockPrize,
    title: t('complete-the-collection-unlock-the-prize'),
    description: t('about-two-dozen-partner-events'),
  },
]
</script>

<template>
  <div class="max-w-360 mx-auto relative lg:mt-43">
    <p
      class="lg:absolute lg:right-0 lg:top-43 lg:text-10 lg:tracking-0.3 lg:leading-12 lg:mt-0 lg:mb-0 lg:px-0 mb-13 mt-5 xl:right-33 gradient-text font-bold max-w-132.5 tracking-wide leading-7 xl:mx-auto uppercase px-5 mx-5 text-2xl"
      v-motion="{
        initial: {
          opacity: 0,
        },
        visibleOnce: {
          opacity: 1,
          transition: {
            duration: 1000,
          },
        },
      }"
    >
      {{ t('look-for-check-in-stations') }}
    </p>

    <NuxtImg
      src="/images/bangkok/check-in.png"
      class="min-h-92 w-full lg:h-164 lg:w-auto object-cover"
    />
  </div>

  <div class="flex items-center justify-center">
    <p
      class="py-5 lg:pt-24 lg:pb-17 lg:text-10 uppercase font-bold text-2xl text-center tracking-wide gradient-text"
    >
      {{ t('how-it-works') }}
    </p>
  </div>

  <div
    class="flex flex-col px-5 gap-5 justify-center pb-8 sm:flex-row sm:flex-wrap sm:mx-auto sm:px-0 sm:pb-10 sm:max-w-285"
  >
    <div
      v-for="item in sliderArray"
      :key="item.id"
      v-motion="{
        initial: {
          opacity: 0,
        },
        visibleOnce: {
          opacity: 1,
          transition: {
            duration: 1000,
          },
        },
      }"
      class="slider-content flex flex-col min-h-70 gap-3.5 relative overflow-hidden rounded-[1.25rem] px-5.5 py-6 w-full sm:w-140 sm:min-h-96 sm:px-7 border border-solid border-[#e0bdff21]"
    >
      <img
        class="w-12.5 h-12.5 sm:w-full sm:h-17.5 object-contain object-left"
        :alt="item.title"
        :src="item.image"
      />
      <p
        class="text-[#C5BFD4] text-lg font-semibold uppercase sm:text-base sm:tracking-wider sm:leading-normal"
      >
        {{ item.title }}
      </p>
      <p class="text-[#C5C5C5] font-light text-sm leading-6.5 tracking-0.2">
        {{ item.description }}
      </p>

      <NuxtImg
        src="/images/bangkok/shadow.png"
        format="webp"
        class="absolute bottom-0 right-0 -z-1 hidden sm:flex"
      />

      <NuxtImg
        src="/images/bangkok/shadow-mobile.png"
        format="webp"
        class="absolute bottom-0 right-0 -z-1 flex sm:hidden"
      />
    </div>
  </div>

  <div class="mx-5 mt-13 md:mt-29">
    <div class="relative max-w-282 mx-auto w-full min-h-54.5 md:min-h-100">
      <div
        class="flex flex-col items-center pt-4.5 px-3.5 md:pt-22.5"
        v-motion="{
          initial: {
            opacity: 0,
          },
          visibleOnce: {
            opacity: 1,
            transition: {
              duration: 1000,
            },
          },
        }"
      >
        <p class="text-xl leading-8 text-center md:text-10 md:leading-normal">
          {{ t('participating-event-organizer') }}
        </p>

        <p
          class="mt-2.5 mb-6 text-base leading-6.5 tracking-0.2 md:text-8 md:leading-normal"
        >
          {{ t('view-our-org-guide') }}
        </p>
        <NuxtLink
          to="https://www.figma.com/deck/1o4as7JxpXya1ucvJVng0C"
          target="_blank"
          class="py-2.5 px-13.5 min-[375px]:px-22.5 md:px-13.5 bg-white rounded-full !text-black font-medium capitalize"
        >
          {{ t('event-guide') }}
        </NuxtLink>
      </div>
      <NuxtImg
        src="/images/bangkok/event-guide.png"
        class="absolute w-full h-full top-0 object-cover -z-1 rounded-[1.25rem]"
      />
    </div>
  </div>
</template>
